import '../styles/Footer.css';

import Grid from '@mui/material/Unstable_Grid2';
import Link from '@mui/material/Link';
import React from 'react';
import SkinThemeService from '../../shared/services/SkinThemeService';
import Typography from '@mui/material/Typography';
import useThemes from '../../shared/hooks/useThemes';

interface FooterProps {
  copyrightStartYear: number;
}
const Footer = (props: FooterProps) => {
  const { skinTheme } = useThemes();
  const currentYear = new Date().getFullYear();
  let yearRange = `${props.copyrightStartYear}`;
  if (props.copyrightStartYear < currentYear) {
    yearRange += ` - ${currentYear}`;
  }

  const links = [
    {
      label: 'Terms',
      link: SkinThemeService.getAssetUrl('auth', 'termsAndConditions')
    },
    {
      label: 'Privacy',
      link: SkinThemeService.getAssetUrl('auth', 'privacyStatement')
    },
    {
      label: 'Contact',
      link: SkinThemeService.getThemeOptionValue(
        skinTheme,
        'container',
        'contactLink'
      )
    }
  ];

  return (
    <div className="footer-container">
      <Grid container alignItems="center">
        <Grid style={{ flex: 1 }}>
          <Grid container alignItems="center">
            {links
              .filter((link) => !!link.link)
              .map((link) => (
                <Grid key={link.label}>
                  <Typography component="span">
                    <Link
                      className="footer-link"
                      color="inherit"
                      href={link.link}
                      target="_blank"
                    >
                      {link.label}
                    </Link>
                  </Typography>
                </Grid>
              ))}
          </Grid>
        </Grid>
        <Grid>
          <Typography component="span">
            <span className="footer-copyright">
              &copy; {currentYear} The Tarn Group
            </span>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
